import type { SxProps, Theme } from '@mui/material';
import { OBSIDIAN, OBSIDIAN_BODY_FONT, OBSIDIAN_DISPLAY_FONT } from '../../../constants/obsidianDashboardTheme';

export const obsidianTableRowSx: SxProps<Theme> = {
    bgcolor: OBSIDIAN.surfaceContainerLow,
    borderRadius: 999,
    px: { xs: 2, lg: 3 },
    py: { xs: 1.75, lg: 2.25 },
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    border: '1px solid transparent',
    '&:hover': {
        bgcolor: OBSIDIAN.surfaceContainer,
        transform: { lg: 'translateY(-2px)' },
    },
};

export const obsidianTableHeaderLabelSx: SxProps<Theme> = {
    fontFamily: OBSIDIAN_BODY_FONT,
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.14em',
    color: OBSIDIAN.onSurfaceVariant,
};

export const obsidianSearchFieldSx: SxProps<Theme> = {
    '& .MuiOutlinedInput-root': {
        height: { xs: 48, sm: 52 },
        borderRadius: 999,
        bgcolor: OBSIDIAN.surfaceContainerHighest,
        fontFamily: OBSIDIAN_BODY_FONT,
        fontSize: 15,
        fontWeight: 500,
        color: OBSIDIAN.onSurface,
        '& fieldset': { border: 'none' },
        '&:hover': { bgcolor: OBSIDIAN.surfaceVariant },
        '&.Mui-focused': {
            bgcolor: OBSIDIAN.surfaceContainerHighest,
            boxShadow: `0 0 0 2px ${OBSIDIAN.primary}66`,
        },
    },
    '& .MuiInputBase-input': {
        py: 1.5,
        '&::placeholder': {
            color: `${OBSIDIAN.onSurfaceVariant}99`,
            opacity: 1,
        },
    },
};

export const obsidianFilterSelectSx: SxProps<Theme> = {
    height: { xs: 48, sm: 52 },
    minWidth: { xs: '100%', sm: 140 },
    borderRadius: 999,
    bgcolor: OBSIDIAN.surfaceContainerHighest,
    fontFamily: OBSIDIAN_BODY_FONT,
    fontSize: 14,
    fontWeight: 700,
    color: OBSIDIAN.onSurface,
    '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
    '&:hover': { bgcolor: OBSIDIAN.surfaceVariant },
    '&.Mui-focused': {
        bgcolor: OBSIDIAN.surfaceContainerHighest,
        boxShadow: `0 0 0 2px ${OBSIDIAN.primary}66`,
    },
    '& .MuiSelect-icon': { color: OBSIDIAN.primary },
};

export const obsidianFilterMenuProps = {
    PaperProps: {
        sx: {
            bgcolor: OBSIDIAN.surfaceContainerHigh,
            border: `1px solid ${OBSIDIAN.outline}44`,
            borderRadius: 2,
            mt: 0.5,
            '& .MuiMenuItem-root': {
                fontFamily: OBSIDIAN_BODY_FONT,
                fontSize: 14,
                fontWeight: 600,
                color: OBSIDIAN.onSurface,
                '&:hover': { bgcolor: OBSIDIAN.surfaceContainer },
                '&.Mui-selected': {
                    bgcolor: `${OBSIDIAN.primary}1a`,
                    color: OBSIDIAN.primary,
                },
            },
        },
    },
};

export const obsidianCellPrimarySx: SxProps<Theme> = {
    fontFamily: OBSIDIAN_DISPLAY_FONT,
    fontWeight: 800,
    fontSize: 15,
    color: OBSIDIAN.onSurface,
};

export const obsidianCellSecondarySx: SxProps<Theme> = {
    fontFamily: OBSIDIAN_BODY_FONT,
    fontSize: 13,
    fontWeight: 500,
    color: OBSIDIAN.onSurfaceVariant,
};

export const obsidianTypeChipSx: SxProps<Theme> = {
    display: 'inline-block',
    fontFamily: OBSIDIAN_DISPLAY_FONT,
    fontSize: 13,
    fontWeight: 600,
    color: OBSIDIAN.onSurface,
    bgcolor: `${OBSIDIAN.surfaceVariant}80`,
    px: 1.5,
    py: 0.5,
    borderRadius: 999,
};

export const obsidianClearFiltersButtonSx: SxProps<Theme> = {
    height: { xs: 48, sm: 52 },
    px: 2.5,
    borderRadius: 999,
    textTransform: 'none',
    fontFamily: OBSIDIAN_DISPLAY_FONT,
    fontWeight: 700,
    fontSize: 14,
    color: OBSIDIAN.onSurfaceVariant,
    bgcolor: OBSIDIAN.surfaceContainerHighest,
    border: `1px solid ${OBSIDIAN.outline}44`,
    '&:hover': {
        bgcolor: OBSIDIAN.surfaceVariant,
        color: OBSIDIAN.onSurface,
    },
};
